import { LocalStoragePage } from "./LocalStoragePage";

export function PagesImportExport() {
  return <LocalStoragePage />;
}

export default PagesImportExport;
